export var GPU_EXERCISE = 'GpuExercise';
export var EXPORTED_EXERCISES = [GPU_EXERCISE];